import { HisInformationItem } from "./HisInformationItem";

export class DepartmentRelatedHisInformation {
  isDefault: boolean;
  departmentCodes: string[];
  items: HisInformationItem[];
}
